import Model from './model.js';

export default class GeoInfo extends Model
{
    constructor(get_info){
        super()
        this.city        = ''
        this.region      = ''
        this.country     = ''
        this.countryCode = ''
        this.latitude    = ''
        this.longitude   = ''

        this.map(get_info)
        this.init()
    }

    map(get_info){
        if(get_info == undefined) return
        this.city        = get_info.city;
        this.region      = get_info.region;
        this.country     = get_info.country;
        this.countryCode = get_info.countryCode;
        this.latitude    = get_info.latitude;
        this.longitude   = get_info.longitude;
    }
}